import { useNavigate } from "react-router-dom";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMountEffect } from "primereact/hooks";

import logo from "@/assets/gire-logo.png";
import { PathNamekRoutes } from "@/router";
import { useLoginUser } from "@/features/auth/services/useLoginUser";
import { useSessionMan } from "@/features/auth/hooks/useSessionMan.hook";
import { Button } from "@/components/atoms/prime/Button";
import { InputTextField } from "@/components/organisms/Form";

import { FormLoginValidations } from "./models/validations";
import { UserLoginT } from "./models";
import { PasswordField } from "./components/PasswordField";

export const LoginPage = () => {
  const { startSession, endSession } = useSessionMan();
  const navigate = useNavigate();

  useMountEffect(() => {
    endSession({ reloadWindow: true });
  });

  const form = useForm<UserLoginT>({
    resolver: zodResolver(FormLoginValidations),
    defaultValues: {
      user: "",
      password: "",
    },
  });
  const { mutateAsync, isPending, isError } = useLoginUser();

  const handleLoginUser: SubmitHandler<UserLoginT> = (formData) => {
    mutateAsync(formData).then((data) => {
      if (data) {
        startSession(data);
        navigate(`/${PathNamekRoutes.WELCOME}`, { replace: true });
      }
    });
  };

  return (
    <div className="grid h-full w-full place-content-center">
      <FormProvider {...form}>
        <form
          className="flex min-h-[500px] flex-col rounded bg-white p-8 shadow-[5px_5px_15px_5px_rgba(0,0,0,0.05)]"
          onSubmit={(e) => {
            e.preventDefault();
            form.handleSubmit(handleLoginUser)();
          }}
        >
          <div className="mx-5 mb-5">
            <header>
              <img alt="" className="max-h-32 w-full object-scale-down" src={logo} />
            </header>
            <legend className="text-center">Inicio de sesión</legend>
            <section className="mt-8 flex flex-col space-y-4">
              <div className="min-h-[76.6px]">
                <InputTextField required id="username" label="Nombre de usuario" name="user" />
              </div>

              <PasswordField required id="password" label="Contraseña" name="password" />
            </section>
            <div>
              <p className="my-3 min-h-6 text-sm font-bold text-red-700">
                {isError && "Credenciales incorrectas"}
              </p>
            </div>
            <Button className="w-full justify-center" loading={isPending} type="submit">
              <p>{isPending ? "INGRESANDO..." : "INGRESAR"}</p>
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
